import { Callout, Group, Stack,Text } from '@ekhodealer/ekho-common/rev';

import { formatNumberWithCommas } from '@common/lib/currency';

import { useGetPlanDetails } from '../api/useGetPlanDetails';

export default function UsageHeader() {
	const { data: planDetails } = useGetPlanDetails();

	const isDepleted = planDetails?.balance === 0;
	const isRunningLow =
		planDetails?.balance != null && planDetails.balance <= 1000 && planDetails.balance > 0;

	const depletedCallout = (
		<Callout
			variant='error'
			title='Credits depleted'
			message='Your credits are used up. Fees are now deducted directly from each sale.'
		/>
	);

	const runningLowCallout = (
		<Callout
			variant='warning'
			title='Running low'
			message='Once credits run out, fees will be deducted per sale'
		/>
	);

	return (
		<Group itemsAlignX='space-between'>
			<Group.Item>
				<Stack>
					<Text size='title300'>
						${formatNumberWithCommas(planDetails?.balance || 0)}
					</Text>
					<Text size='bodySmall' color='secondary'>
						Remaining <span className='divider'>|</span> Expires{' '}
						<b>{planDetails?.nextExpiryDate}</b>
					</Text>
				</Stack>
			</Group.Item>
			<Group.Item>
				{isDepleted && depletedCallout}
				{isRunningLow && runningLowCallout}
			</Group.Item>
		</Group>
	);
}
